import styled from 'styled-components';

export const SetStyled = styled.div`
  margin-top: 1.5rem;

  >p {
    font-size: 1.5rem;
    color: #5a5a5a;
    text-align: start;
    margin-left: 1.5rem;
    margin-bottom: 2.5rem;
  }

  h3 {
    margin-left: 1rem;
    margin-bottom: 1rem;
    text-align: start;
    font-weight: bold;
    font-size: 2rem;
    margin-right: auto;
    }
  >ul {
    position: relative;
  }
  
`

export const SetHeader = styled.div`
  display: flex;
  align-items: center;

  h2 {
      font-weight: bold;
      font-size: 2.5rem;
      margin-left: 1rem;
      margin-right: 1rem;
    }
`

export const SongHeader = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1.5rem;
`

export const LoadingContainer = styled.div`
  margin-left: 1rem;
`

